const MENU_SCRAPING_TASKS_SORTING_CRITERIA = {
  MODIFIED_DATE: 'MODIFIED_DATE',
  SCRAPED_DATE: 'SCRAPED_DATE',
}

export default MENU_SCRAPING_TASKS_SORTING_CRITERIA
